import React, { useState } from 'react';
import { AdvancedSearch } from './AdvancedSearch';
import './SearchSpace.css';
import { SimpleSearch } from './SimpleSearch';

export function Search() {
  const [searchType, setSearchType] = useState(true);

  const typeToSearch = (childdata) => {
    setSearchType(childdata);
  };
  return (
    <div>
      { searchType
        ? <SimpleSearch type={typeToSearch} />
        : <AdvancedSearch type={typeToSearch} />}
    </div>
  );
}
